/**
 * deriveProjectSlug — the slug the create modal sends to POST /api/projects.
 *
 * The server's createProjectSchema.slug is z.string().min(1).max(50)
 * (packages/server/src/routes/projects.ts), so the derived slug must be
 * clamped and never empty — pre-2026-08-04 a name longer than ~50 slug
 * characters, or one with no [a-z0-9] at all (CJK, emoji), 400'd the whole
 * create. The 'project' fallback mirrors generateUniqueSlug's own
 * `base = slug || 'project'` (packages/server/src/services/displayId.ts),
 * and the server dedupes team-wide (project, project-2, ...), so collisions
 * from clamping or the fallback are handled there.
 */

/** Mirrors createProjectSchema.slug max — packages/server/src/routes/projects.ts. */
export const PROJECT_SLUG_MAX_LENGTH = 50;

export function deriveProjectSlug(name: string): string {
  const slug = name
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .slice(0, PROJECT_SLUG_MAX_LENGTH);
  return slug || 'project';
}
